import React from "react";

// Debug log to confirm this file is loaded
console.log("LandingPage.js loaded at", new Date().toLocaleString());

export default function LandingPage({ account, onLogin, onLogout }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#ffffff",
      }}
    >
      {/* Custom Logo */}
      <div style={{ marginBottom: 20 }}>
        <img
          src="/logo.png"
          alt="Company Logo"
          style={{ width: 200, height: "auto" }} // Removed border
          onError={(e) => console.error("Logo failed to load:", e)}
        />
      </div>

      <h1 style={{ color: "#0078d4", marginBottom: 20 }}>
        Azure Certificate Validity Tracker
      </h1>

      {!account ? (
        <button
          onClick={onLogin}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "10px 20px",
            fontSize: 16,
            backgroundColor: "#0078d4",
            color: "white",
            border: "none",
            borderRadius: 5,
            cursor: "pointer",
            gap: 10,
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2L2 12L12 22L22 12L12 2ZM12 8V16M8 12H16"
              fill="white"
              stroke="white"
              strokeWidth="2"
            />
          </svg>
          Sign in with Azure AD
        </button>
      ) : (
        <>
          <p style={{ fontSize: 18, marginBottom: 10 }}>
            Welcome, <strong>{account.username}</strong>
          </p>
          <button
            onClick={onLogout}
            style={{
              padding: "10px 20px",
              fontSize: 16,
              backgroundColor: "#d83b01",
              color: "white",
              border: "none",
              borderRadius: 5,
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </>
      )}
    </div>
  );
}